import React from 'react';

import cn from 'classnames';

import { downloadFile } from '@shared/helpers';
import { Icon, UiButton, UiText } from '@shared/ui';

import cls from './PreviewFileHeader.module.css';

interface PreviewFileHeaderProps {
    classes?: string;
    fileSrc?: string;
    fileName?: string;
    onClose?: () => void;
}

export const PreviewFileHeader = ({
    classes,
    onClose,
    fileSrc,
    fileName,
}: PreviewFileHeaderProps) => (
    <div className={cn(cls.PreviewFileHeader, [classes])}>
        <UiButton variant="text" onClick={onClose} startIcon={<Icon iconName="back" />} />
        <UiText tag="span" classes={cls.name} variant="heading">
            {fileName}
        </UiText>
        <UiButton
            onClick={async () => {
                await downloadFile(fileSrc, fileName);
            }}
            variant="text"
            startIcon={<Icon iconName="filesDownload" fill="#F5F5F5" />}
        />
    </div>
);
